export default {
  statusCode: 0,
  message: '',
  meta: {},
};
